// Types and Interfaces
export enum VirtualGamepadTemplate {
  Fighting = "FIGHTING",
  Generic = "GENERIC",
  Racing = "RACING",
  Simplified = "SIMPLIFIED",
}

export interface ButtonStates {
  [key: string]: boolean;
}

export interface Joystick {
  x: number;
  y: number;
}

export interface GamepadState {
  buttons: ButtonStates;
  joystick: Joystick;
}

export interface MouseSimulationHandlers {
  shouldSimulateMouseEvents?: () => boolean;
  simulateMouseMovement?: (joystickX: number, joystickY: number) => void;
  simulateMouseEvent?: (
    type: "mousedown" | "mouseup",
    button: "left" | "right",
  ) => void;
  stopMouseSimulation?: () => void;
}

export interface VirtualGamepadProps extends MouseSimulationHandlers {
  onStateChange?: (state: GamepadState) => void;
  sendMessage?: (message: string) => void;
  onToggleMenu?: () => void;
  isActive?: boolean;
  template?: VirtualGamepadTemplate;
  dimmed?: boolean;
}

export type ButtonKey =
  | "up"
  | "down"
  | "left"
  | "right"
  | "a"
  | "b"
  | "x"
  | "y"
  | "l1"
  | "r1"
  | "l2"
  | "r2"
  | "l3"
  | "r3"
  | "select"
  | "start"
  | "home";

// Standard gamepad button mapping
export const BUTTON_MAPPING: { [key in ButtonKey]: number } = {
  a: 0,
  b: 1,
  x: 2,
  y: 3,
  l1: 4,
  r1: 5,
  l2: 6,
  r2: 7,
  select: 8, // select/back
  start: 9, // menu/start
  l3: 10, // left stick press
  r3: 11, // right stick press
  up: 12,
  down: 13,
  left: 14,
  right: 15,
  home: 16,
};

export const VIRTUAL_GAMEPAD_INDEX = 0;
export const DEADZONE = 0.05;
export const INACTIVITY_TIMEOUT_MS = 5000;
